

import router from '@/router/router'

var List_Editor
(function() {
    /**
     * 提供拓扑图面板相关操作的函数集，编辑器继承其全部功能
     */
    function TopologyPanel() {
    }

    /**
     * 重置拓扑图
     */
    TopologyPanel.prototype.resetTopology = function (topologyJson) {
        editor.stageMode = 'normal'
        JTopo.replaceStageWithJson(topologyJson, editor)
        if (editor.stage && editor.scene && editor.scene.childs && editor.scene.childs.length > 0) {
            editor.stage.centerAndZoom()
        }
    }

    /**
     * 编辑器对象,原型继承拓扑图面板对象,提供编辑器的主要功能
     */
    function TopologyEditor() {
        // 绘图参数
        this.config = {
            // Stage属性
            stageFrames: 500,                       // 舞台播放的帧数/秒
            defaultScal: 0.95,                      // 鼠标滚轮缩放比例
            eagleEyeVsibleDefault: false,         // 是否显示鹰眼对象
            // Node属性
            nodeAlpha: 1,                           // 节点透明度,取值范围[0-1]
            nodeStrokeColor: '22,124,255',        // 节点描边的颜色
            nodeFillColor: '22,124,255',          // 节点填充颜色
            nodeShadow: false,                     // 节点是否显示阴影
            nodeShadowColor: 'rgba(0,0,0,0.5)',  // 节点阴影的颜色
            nodeFont: '12px Consolas',            // 节点字体
            nodeFontColor: 'black',               // 节点文字颜色,如"255,255,0"
            nodeDefaultWidth: 30,                 // 新建节点默认宽
            nodeDefaultHeight: 30,                // 新建节点默认高
            nodeBorderColor: 'black',            // 节点容器边框颜色,如"255,255,0"
            nodeBorderRadius: 30,                // 节点半径，非圆节点有此属性会变形
            nodeRotateValue: 0.5,                // 节点旋转的角度(弧度)
            nodeScale: 0.2,                       // 节点缩放幅度(此处保证X和Y均等缩放)
            // Link属性
            linkAlpha: 1,                         // 连线透明度,取值范围[0-1]
            linkStrokeColor: '123,165,241',     // 连线的颜色
            linkFillColor: '123,165,241',
            linkShadow: false,                   // 是否显示连线阴影
            linkShadowColor: 'rgba(0,0,0,0.5)',
            linkFont: '12px Consolas',           // 节点字体
            linkFontColor: 'black',              // 连线文字颜色,如"255,255,0"
            linkArrowsRadius: 0,                 // 线条箭头半径
            linkDefaultWidth: 3,                 // 连线宽度
            linkOffsetGap: 40,                   // 折线拐角处的长度
            linkDirection: 'horizontal',        // 折线的方向
            // Container属性
            containerAlpha: 1,
            containerStrokeColor: '22,124,255',
            containerFillColor: '22,124,255',
            containerShadow: false,
            containerShadowColor: 'rgba(0,0,0,0.5)',
            containerFont: '12px Consolas',
            containerFontColor: 'black',
            containerBorderColor: 'black',
            containerBorderRadius: 30,
        }
        // 布局参数
        this.layout = {}
        // 绘图区属性
        this.stage = null
        this.scene = null
        // 当前模式
        this.stageMode = 'normal'
        // 默认连线类型
        this.lineType = 'line'
        // 当前选择的节点对象
        this.currentNode = null
        // 当前选择的连线对象
        this.currentLink = null
        // 节点右键菜单DOM对象
        this.nodeMenu = $('#tc_node-menu')
        // 连线右键菜单DOM对象
        this.lineMenu = $('#line-menu')
        // 全局右键菜单
        this.mainMenu = $('#main-menu')
        // 布局管理菜单
        this.layoutMenu = $('#layout-menu')
        // 节点文字方向
        this.nodeTextPosMenu = $('#node-text-pos-menu')
        // 节点分组菜单
        this.groupMangeMenu = $('#group-mange-menu')
        // 节点对齐菜单
        this.groupAlignMenu = $('#group-align-menu')
        this.alignGroup = $('#align-group')
        // 分组的容器管理菜单
        this.containerMangeMenu = $('#container-mange-menu')
        // 调用构造函数,继承TopologyPanel类
        TopologyPanel.call(this)
    }

    // 原型继承
    TopologyEditor.prototype = new TopologyPanel()

    /**
     * 菜单初始化
     */
    TopologyEditor.prototype.initMenus = function () {
        let self = this
        let nodeMenu = $('#tc_node-menu');
        // 右键菜单事件处理(右键一级菜单)
        nodeMenu.on('click', function (event) {
            // 菜单文字对应事件
            let text = $.trim($(event.target).text())
            if(text === '控制设备') {
                

            }
            // 关闭菜单
            $(this).hide()
        })

        nodeMenu.on('mouseover', function (event) {
            // 菜单文字
            let text = $.trim($(event.target).text())
            
            console.log("mouseover");
        })
    }

    /**
     * 编辑器初始化方法,根据请求返回结果加载空白的或者指定结构的拓扑编辑器
     * @param topologyGuid  拓扑记录ID
     * @param backImg     背景图片
     * @param topologyJson    拓扑JSON结构
     */
    TopologyEditor.prototype.init = function (topologyGuid, backImg, topologyJson) {
        // 创建jTopo舞台屏幕对象
        let canvas = document.getElementById('topology-canvas')
        canvas.width = $('#topology-body').width();
        canvas.height = $('#topology-body').height();

        if (!topologyJson) {
            // alert('加载拓扑编辑器失败!')
            return
        }
        this.topologyGuid = topologyGuid

        // 加载空白的编辑器
        if (topologyJson === '-1') {
            this.stage = new JTopo.Stage(canvas)         // 定义舞台对象
            this.scene = new JTopo.Scene(this.stage)    // 定义场景对象
        } else {
            this.stage = JTopo.createStageFromJson(topologyJson, canvas)    // 根据保存好的jsonStr(拓扑结构)创建舞台对象
            this.scene = this.stage.childs[0]                           // 场景对象列表,childs是舞台的属性
        }
        // 滚轮缩放
        this.stage.frames = this.config.stageFrames       // 设置当前舞台播放的帧数/秒
        this.stage.wheelZoom = this.config.defaultScal    // 鼠标滚轮缩放操作比例
        this.stage.eagleEye.visible = this.config.eagleEyeVsibleDefault    // 是否开启鹰眼
        this.stage.mode = this.stageMode
        // 设置舞台模式
        // 背景由样式指定
        this.scene.background = backImg;
        // 用来连线的两个节点
        this.tempNodeA = new JTopo.Node('tempA')
        this.tempNodeA.setSize(1, 1)
        this.tempNodeZ = new JTopo.Node('tempZ')
        this.tempNodeZ.setSize(1, 1)
        this.beginNode = null
        this.link = null
        let self = this

        // 初始化菜单
        // this.initMenus()

        // 鼠标进入事件
        this.scene.mouseover(function (event) {
            let nodeInfoBox = $('#node_infobox');
            Timer.start();
            // 进入某个节点
            if (event.target != null && event.target instanceof JTopo.Node && event.target.nodeParams && editor.stageMode !== 'edit') {
            // 节点提示内容盒子
                
                // 记录鼠标触发位置在canvas中的相对位置
                let menuY = event.layerY ? event.layerY : event.offsetY
                let menuX = event.layerX ? event.layerX : event.offsetX
                menuY = menuY + 50;
                menuX = menuX + 50;
                // 判断边界出是否能完整显示弹出菜单
                if (menuX + nodeInfoBox.width() >= self.stage.width) {
                    menuX -= nodeInfoBox.width()
                }
                if (menuY + nodeInfoBox.height() >= self.stage.height) {
                    menuY -= nodeInfoBox.height()
                }
                nodeInfoBox.css({
                    'top': menuY,
                    'left': menuX,
                })
                
                // 右侧节点信息展示区
				// console.log(event.target.nodeParams.nodeMeterInfo)
                let arr = event.target.nodeParams.nodeMeterInfo.split('$');
                let HouseName = arr[0],
                    TerminalSerial = arr[1],
                    CollectorSerial = arr[2],
                    DevType = arr[3];
                let strDevType = DevType == 1 ? "风盘" : "风柜"
                // 右侧信息栏
                if (arr && arr.length === 4) {
                    $('.TerminalSerial').html(TerminalSerial);
                    $('.HouseName').html(HouseName);
                    $('.CollectorSerial').html(CollectorSerial);
                    $('.DevType').html(strDevType);
                }

                let data = showMeterInfo(event.target.nodeParams.nodeOID)
                
                $('[name=node_TerminalSerial]').html(TerminalSerial);
                $('[name=current_Type]').html(strDevType);
                $('[name=current_HouseName]').html(HouseName);
				// console.log(data)
                // 节点状态栏
                if(data) {
					// $('.DevType').html(data.model);
                    $('[name=current_poweron]').html(data.status);
                    $('[name=node_TerminalModel]').html(data.model);
                    $('[name=current_speed]').html(data.speed);
                    $('[name=current_valveon]').html(data.valveon);
                    $('[name=current_mode]').html(data.mode);
                    $('[name=current_temperature]').html(data.temperature);
                    $('[name=current_room_temperature]').html(data.room_temperature);
                    
                }
                if ($('#tc_node-menu').is(':hidden')) {
                    nodeInfoBox.stop().fadeIn('easing')
                } else {
                    nodeInfoBox.stop().fadeOut();
                }
                // 进入某个连线
            } else if (event.target != null && event.target instanceof JTopo.Link && event.target.linkTooltip && editor.stageMode !== 'edit') {
                $('#node_infobox').stop().fadeOut();
            } else {
                // 鼠标进入别的地方
                $('#node_infobox').stop().fadeOut();
            }
        })

        // 鼠标离开事件
        this.scene.mouseout(function (event) {
            let timeSpan = Timer.pause()
            // 消抖
            if (timeSpan > 100) {
                $('#node_infobox').stop().fadeOut()
                Timer.stop()
            }
        })

        // 鼠标单击节点事件
        this.scene.click(function (event) {
            if (event.target) {
                self.currentNode = event.target
                if (self.currentNode.nodeParams) {
                    // 右侧节点信息展示区
                    let arr = self.currentNode.nodeParams.nodeMeterInfo.split('$');
                    if (arr && arr.length === 4) {
                        let HouseName = arr[0],
                            TerminalSerial = arr[1],
                            CollectorSerial = arr[2],
                            DevType = arr[3];
                        $('.TerminalSerial').html(TerminalSerial);
                        $('.HouseName').html(HouseName);
                        $('.CollectorSerial').html(CollectorSerial);
                        let strDevType = DevType == 1? "风盘" : "风柜"
                        $('.DevType').html(strDevType);
                    }
                }
            } else {
                // 单击舞台空白处
                $('.node-tooltip').css('display', 'none')
                return
            }

            // 单击某个节点
            if (event.target != null && event.target instanceof JTopo.Node && event.target.nodeTooltip && editor.stageMode !== 'edit') {
                let currentNodeParams = self.currentNode.nodeParams
                if (currentNodeParams && currentNodeParams.jumpRoute) {
                    window.open(currentNodeParams.jumpRoute)
                }
            } else {
                // 单击别的地方
                $('.node-tooltip').css('display', 'none')
            }
        })

        // 双击事件
        this.scene.dbclick(function (event) {
            if (event.target) {
                self.currentNode = event.target
            } else {
                // 双击了舞台空白处
                return
            }
            // 只处理双击节点事件
            if (event.target != null && event.target instanceof JTopo.Node) {
                if(event.target.nodeType === 'DE') {
                    router.push('/equipmentControl1');
                }
            }
        })

        // 监听鼠标松开事件
        // 处理右键菜单、左键连线
        // event.button: 0-左键 1-中键 2-右键
        this.scene.mouseup(function (event) {
            let nodeMenu = $('#tc_node-menu');
            if (event.target && event.target instanceof JTopo.Node) {
                self.currentNode = event.target
            } else if (event.target && event.target instanceof JTopo.Link) {
                self.currentLink = event.target
            }
            if (event.target && event.target instanceof JTopo.Node && event.target.layout && event.target.layout.on && event.target.layout.type && event.target.layout.type !== 'auto') {
                JTopo.layout.layoutNode(this, event.target, true, event)
            }
            if (event.button === 2) {                      // 右键菜单
                $('div[id$=\'-menu\']').hide()
                $('#node_infobox').stop().fadeOut(50); //隐藏状态信息
                let menuY = event.layerY ? event.layerY : event.offsetY
                let menuX = event.layerX ? event.layerX : event.offsetX
                // 记录鼠标触发位置在canvas中的相对位置
                self.xInCanvas = menuX
                self.yInCanvas = menuY
                if (event.target) {
                    if (event.target instanceof JTopo.Node) {          // 处理节点右键菜单事件
                        let selectedNodes = self.utils.getSelectedNodes()
                        // 如果是节点多选状态弹出分组菜单
                        if (selectedNodes && selectedNodes.length > 1) {
                            // 选择多个

                        } else {
                            if(event.target.nodeType === 'DE') {
                                // 判断边界出是否能完整显示弹出菜单
                                if (menuX + nodeMenu.width() >= self.stage.width) {
                                    menuX -= nodeMenu.width()
                                }
                                if (menuY + nodeMenu.height() >= self.stage.height) {
                                    menuY -= nodeMenu.height()
                                }

                                menuY = menuY + 30;
                                menuX = menuX + 30;

                                nodeMenu.css({
                                    top: menuY,
                                    left: menuX
                                }).show(100);
                            }
                        }
                    } else if (event.target instanceof JTopo.Link) {     // 连线右键菜单
                       
                    } else if (event.target instanceof JTopo.Container) {        // 容器右键菜单
                       
                    }
                } else {
                    
                }
            } else if (event.button === 1) {          // 中键

            } else if (event.button === 0) {          // 左键松开事件
                if (event.target != null && event.target instanceof JTopo.Node && !self.isSelectedMode && editor.stageMode === 'edit') {
                 
                } else {
                    if (self.link) {
                        this.remove(self.link)
                    }
                    self.beginNode = null
                }
            }
        })

        // 单击编辑器隐藏右键菜单
        this.stage.click(function (event) {
            if (event.button === 0) {
                // 关闭弹出菜单（div）
                $('div[id$=\'-menu\']').hide()
            }
        })

        // 
        // 按下ctrl进入多选模式，此时选择节点不能画线
        $(document).keydown(function (e) {
            if (e.which === 17 || e.which === 32) {              // 单独按下ctrl
                $('#topology-canvas').css({
                    "cursor": "move"
                })
                self.isSelectedMode = true
                self.scene.mode = "drag"
            } 
        })
        $(document).keyup(function (e) {
            if (e.which === 17 || e.which === 32) {
                $('#topology-canvas').css({
                    "cursor": "default"
                })
                self.isSelectedMode = false
                self.scene.mode = "normal"
                return false
            }
        })

        // 第一次进入拓扑编辑器,生成stage和scene对象
        if (topologyJson === '-1') {
            this.saveTopology(false)
        }
    }

    // 编辑器实例
    var editor = new TopologyEditor('mainControl')

    // 工具方法
    editor.utils = {
        // 获取所有分组
        getAllContainers: function () {
            return editor.stage.find('container')
        },
        // 获取所有节点
        getAllNodes: function () {
            return editor.stage.find('node')
        },
        // 获取所有连线
        getAllLinks: function () {
            return editor.stage.find('link')
        },
        // 获取所有选择的节点实例
        getSelectedNodes: function () {
            let selectedNodes = []
            let nodes = editor.scene.selectedElements
            nodes.forEach(function (n) {
                if (n.elementType === 'node') {
                    selectedNodes.push(n)
                }
            })
            return selectedNodes
        },
        // 节点分组合并
        toMerge: function () {
            let selectedNodes = this.getSelectedNodes()
            // 不指定布局的时候,容器的布局为自动(容器边界随元素变化）
            let container = new JTopo.Container()
            container.textPosition = 'Top_Center'
            container.fontColor = editor.config.nodeFontColor
            container.borderColor = editor.config.nodeBorderColor
            container.borderRadius = editor.config.nodeBorderRadius
            editor.scene.add(container)
            selectedNodes.forEach(function (n) {
                container.add(n)
            })
        },
        // 分组拆除
        toSplit: function () {
            if (editor.currentNode instanceof JTopo.Container) {
                editor.currentNode.removeAll()
                editor.scene.remove(editor.currentNode)
            }
        },
        // 删除连线
        deleteLine: function () {
            if (editor.currentNode instanceof JTopo.Link) {
                editor.scene.remove(editor.currentNode)
                // if (editor.currentNode.id)
                //     editor.deleteNodeById(editor.currentNode.id, "link");
                editor.currentNode = null
                editor.lineMenu.hide()
            }
        },
        // 删除节点
        deleteNode: function (n) {
            editor.scene.remove(n)
            // if (n.id)
            //     editor.deleteNodeById(n.id, n.elementType, n.dataType);
            editor.currentNode = null
            // 连线重置
            editor.beginNode = null
            if (editor.link) {
                editor.scene.remove(editor.link)
            }
            editor.link = null
        },
        // 删除选择的节点
        deleteSelectedNodes: function () {
            // if (editor.stageMode !== 'edit') {
            //   return false
            // }
            let self = this
            let nodes = editor.scene.selectedElements
            if (nodes && nodes.length > 0) {
                for (let i = 0; i < nodes.length; i++) {
                    self.deleteNode(nodes[i])
                }
            }
        },
        // 放大
        scalingBig: function () {
            if (editor.currentNode instanceof JTopo.Node) {
                editor.currentNode.scaleX += editor.config.nodeScale
                editor.currentNode.scaleY += editor.config.nodeScale
            } else {
                editor.stage.zoomOut(editor.stage.wheelZoom)
            }
        },
        // 缩小
        scalingSmall: function () {
            if (editor.currentNode instanceof JTopo.Node) {
                editor.currentNode.scaleX -= editor.config.nodeScale
                editor.currentNode.scaleY -= editor.config.nodeScale
            } else {
                editor.stage.zoomIn(editor.stage.wheelZoom)
            }
        },
        // 顺时针旋转
        rotateAdd: function () {
            if (editor.currentNode instanceof JTopo.Node) {
                editor.currentNode.rotate += editor.config.nodeRotateValue
            }
        },
        // 逆时针旋转
        rotateSub: function () {
            if (editor.currentNode instanceof JTopo.Node) {
                editor.currentNode.rotate -= editor.config.nodeRotateValue
            }
        },
        // 清空编辑器
        clearTopology: function () {
            // 删除节点表对应的节点记录
            editor.deleteAllNodes()
        },
        // 拓扑图预览
        showPic: function () {
            editor.stage.saveImageInfo()
        },
        exportAsImage: function () {
            editor.stage.exportAsImage()
        },
        setEditMode: function () {
            editor.stageMode = 'edit'
        },
        setNormalMode: function () {
            editor.stageMode = 'normal'
        },
        // 复制节点
        cloneNode: function (n) {
            if (n instanceof JTopo.Node) {
                let newNode = new JTopo.Node()
                n.serializedProperties.forEach(function (i) {
                    // 只复制虚拟机的模板属性
                    // if (i == "templateId" && n.dataType != "VM") return true;
                    newNode[i] = n[i]
                })
                newNode.nodeId = generateUUID()
                newNode.alpha = editor.config.nodeAlpha
                newNode.strokeColor = editor.config.nodeStrokeColor
                newNode.fillColor = editor.config.nodeFillColor
                newNode.shadow = editor.config.nodeShadow
                newNode.shadowColor = editor.config.nodeShadowColor
                newNode.font = editor.config.nodeFont
                newNode.fontColor = editor.config.nodeFontColor
                newNode.borderRadius = null
                newNode.layout = n.layout
                newNode.selected = false
                // var deviceNum = ++editor.modeIdIndex;
                // newNode.deviceId = "device" + deviceNum;
                newNode.setLocation(n.x + n.width, n.y + n.height)
                newNode.text = n.text
                newNode.setImage(n.image)
                editor.scene.add(newNode)
            }
        },
        // 复制选择的节点
        cloneSelectedNodes: function () {
            let self = this
            let nodes = editor.scene.selectedElements
            nodes.forEach(function (n) {
                if (n.elementType === 'node') {
                    self.cloneNode(n)
                }
            })
        },
        // 全屏显示
        showInFullScreen: function (element, method) {
            let usablePrefixMethod;
            ['webkit', 'moz', 'ms', 'o', ''].forEach(function (prefix) {
                if (usablePrefixMethod) {
                    return
                }
                if (prefix === '') {
                    // 无前缀，方法首字母小写
                    // method = method.slice(0, 1).toLowerCase() + method.slice(1)
                }
                let typePrefixMethod = typeof element[prefix + method]
                if (typePrefixMethod + '' !== 'undefined') {
                    if (typePrefixMethod === 'function') {
                        usablePrefixMethod = element[prefix + method]()
                    } else {
                        usablePrefixMethod = element[prefix + method]
                    }
                }
            }
            )
            return usablePrefixMethod
        },
        // 居中显示
        showInCenter: function () {
            editor.stage.centerAndZoom()
        },
        // 获取所有的容器对象
        getContainers: function () {
            let containers = []
            editor.stage.childs.forEach(function (s) {
                s.childs.forEach(function (n) {
                    if (n.elementType === 'container') {
                        containers.push(n)
                    }
                })
            })
            return containers
        },
        // 根据指定的key返回节点实例
        getNodeByKey: function (key, value) {
            let node = null
            editor.stage.childs.forEach(function (s) {
                s.childs.forEach(function (n) {
                    if (n.elementType === 'node' && n[key] === value) {
                        node = n
                        return node
                    }
                })
            })
            return node
        },
        // 撤销对节点的操作
        cancleNodeAction: function () {
            if (editor.currentNode.currStep <= 0) {
                return
            }
            --editor.currentNode.currStep
            for (let p in editor.currentNode) {
                if (p !== 'currStep') {
                    editor.currentNode[p] = (editor.currentNode.historyStack[editor.currentNode.currStep])[p]
                }
            }
        },
        // 重做节点操作
        reMakeNodeAction: function () {
            if (editor.currentNode.currStep >= editor.currentNode.maxHistoryStep ||
                editor.currentNode.currStep >= editor.currentNode.historyStack.length - 1) {
                return
            }
            editor.currentNode.currStep++
            for (let q in editor.currentNode) {
                if (q !== 'currStep') {
                    editor.currentNode[q] = (editor.currentNode.historyStack[editor.currentNode.currStep])[q]
                }
            }
        },
        // 保存节点新的状态
        saveNodeNewState: function () {
            // 如果历史栈超过最大可记录历史长度，丢弃第一个元素
            if (editor.currentNode.historyStack.length >= editor.currentNode.maxHistoryStep + 1) {
                editor.currentNode.historyStack.shift()
            }
            editor.currentNode.historyStack.push(JTopo.util.clone(editor.currentNode))
            editor.currentNode.currStep = editor.currentNode.historyStack.length - 1
        },
        // 保存节点初始状态,便于回退
        saveNodeInitState: function () {
            if (!editor.currentNode.hasInitStateSaved) {
                editor.currentNode.historyStack.push(JTopo.util.clone(editor.currentNode))
                editor.currentNode.hasInitStateSaved = true
            }
        },
        // 查找节点,便居中闪动显示
        findNodeAndFlash: function (text) {
            if (!text) return
            // var self = this
            text = text.trim()
            let nodes = editor.stage.find('node[text="' + text + '"]')
            if (nodes.length > 0) {
                let node = nodes[0]
                this.unSelectAllNodeExcept(node)
                node.selected = true
                let location = node.getCenterLocation()
                // 查询到的节点居中显示
                editor.stage.setCenter(location.x, location.y)

                function nodeFlash(node, n) {
                    if (n === 0) {
                        editor.utils.unSelectAllNodeExcept(node)
                        return
                    }
                    node.selected = !node.selected
                    setTimeout(function () {
                        nodeFlash(node, n - 1)
                    }, 300)
                }

                // 闪烁几下
                nodeFlash(node, 10)
            } else {
                // alert('没有找到该节点,请输入完整的节点名称!')
            }
        },
        // 取消出参数节点外所有节点的选中状态
        unSelectAllNodeExcept: function (node) {
            editor.stage.childs.forEach(function (s) {
                s.childs.forEach(function (n) {
                    // id属性无有效值，说明该节点没有保存到数据库
                    if (n.nodeId !== node.nodeId) {
                        n.selected = false
                    }
                })
            })
        }
    }    
    
    List_Editor = editor;

    // 获取表计实时读数
    function showMeterInfo(id) {
        if (List_Editor.meterInfo && List_Editor.meterInfo.length) {
            let result = List_Editor.meterInfo.filter(v=>{
                return v.terminalid == id
            })
            if (result.length>0) {
                return result[0];
            }else{
                return false
            }
        }
    }

    
})()

export default List_Editor;
